import { render, staticRenderFns } from "./SidLottieIcon.vue?vue&type=template&id=0e39c039"
import script from "./SidLottieIcon.vue?vue&type=script&lang=js"
export * from "./SidLottieIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports